// extracted by mini-css-extract-plugin
export default {"buttonLink":"lsqOp","modalSection":"ulqSQ","subHeading":"xJ47+","contentBlock":"eLUTt","closeIconClassName":"eJnY8","button":"sJzXS"};